// removed by extract-text-webpack-plugin
module.exports = {"buttonYes":"buttonYes--2d5sm","buttonIcon":"buttonIcon--3i7Ay","buttonNo":"buttonNo--2vkZ6","text":"text--9gWDi","active":"active--3PG2k"};